import { render, staticRenderFns } from "./CardBodyV2.vue?vue&type=template&id=4d33a690"
import script from "./CardBodyV2.vue?vue&type=script&lang=js"
export * from "./CardBodyV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports